import { DISCARDED, SKIPPED } from '@datadog/browser-core';
import { RumEventType } from '../../rawRumEvent.types';
export function startSessionContext(hooks, sessionManager, recorderApi, viewHistory) {
  hooks.register(0
  /* HookNames.Assemble */
  , function (_ref) {
    var eventType = _ref.eventType,
        startTime = _ref.startTime;
    var session = sessionManager.findTrackedSession(startTime);
    var view = viewHistory.findView(startTime);

    if (!session || !view) {
      return DISCARDED;
    }

    var hasReplay;
    var sampledForReplay;
    var isActive;

    if (eventType === RumEventType.VIEW) {
      hasReplay = recorderApi.getReplayStats(view.id) ? true : undefined;
      sampledForReplay = session.sessionReplay === 1
      /* SessionReplayState.SAMPLED */
      ;
      isActive = view.sessionIsActive ? undefined : false;
    } else {
      hasReplay = recorderApi.isRecording() ? true : undefined;
    }

    return {
      type: eventType,
      session: {
        id: session.id,
        type: "user"
        /* SessionType.USER */
        ,
        has_replay: hasReplay,
        sampled_for_replay: sampledForReplay,
        is_active: isActive
      }
    };
  });
  hooks.register(1
  /* HookNames.AssembleTelemetry */
  , function (_ref2) {
    var startTime = _ref2.startTime;
    var session = sessionManager.findTrackedSession(startTime);

    if (!session) {
      return SKIPPED;
    }

    return {
      session: {
        id: session.id
      }
    };
  });
}